var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.25,
  stroke: "#333",
  strokeWidth: 1.5,
  transform: "matrix(-1 0 0 1 38 10)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "m17.453 23.582 4.42-4.339a.854.854 0 0 1 1.195.003.826.826 0 0 1-.003 1.18L20.1 23.339h10.055a.84.84 0 0 1 .846.834.84.84 0 0 1-.846.834H20.1l2.967 2.913a.827.827 0 0 1 .002 1.18.854.854 0 0 1-1.196.003l-4.418-4.339a.83.83 0 0 1 0-1.182"
})));
export { SvgIconLeftArrow as ReactComponent };